import { createContext, useContext } from 'react';

import { WorkflowScopeType } from '@invenco/common-domain/enums';

export const WorkflowScopeTypeContext = createContext<WorkflowScopeType>(WorkflowScopeType.ACCOUNT);

export const useWorkflowScopeType = () => useContext(WorkflowScopeTypeContext);
